<template>
  <div class="checkRecord">
    <div class="recordList" v-if="recordlist.length > 0">
      <div class="recordlist-head">
        <div class="title-address">签到地点</div>
        <div class="title-time">签到时间</div>
      </div>
      <div class="recordlist-body">
        <div
          class="recordlist-item"
          v-for="(item, index) in recordlist"
          :key="item.eventSignRecordId"
          :class="{'even-row': (index + 1) % 2 === 0}"
        >
          <div class="item-address">{{ item.signName }}</div>
          <div class="item-time">{{ item.signTimeString }}</div>
        </div>
      </div>
    </div>
    <div class="nomore" v-else>
      <div class="nomore-text"><span class="text">您没有签到</span></div>
    </div>
  </div>
</template>

<script>
import {signdetail} from '@/api'
export default {
  data() {
    return {
      recordlist: []
    }
  },

  components: {},
  mounted() {
    this.getCheckRecord()
  },
  methods: {
    getCheckRecord() {
      const params = {
        eventSignId: this.$route.query.id
      }
      signdetail(params).then(res => {
        if (res.success) {
          console.log(res.data)

          this.recordlist = res.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.checkRecord {
  width: 100%;
  min-height: calc(100vh - 210px);
  background-color: #fff;
  // padding: 16px 0 0 0;
  .recordList {
    padding: 16px 0 0 0;
    .recordlist-head {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 53px;
      .title-address {
        width: 50%;
        font-size: 15px;
        font-weight: 500;
        color: #262626;
        padding: 16px;
        text-align: left;
        display: flex;
        align-items: center;
        background-color: #f8f8f8;
      }
      .title-time {
        width: 50%;
        font-size: 15px;
        font-weight: 500;
        color: #262626;
        padding: 16px;
        text-align: left;
        display: flex;
        align-items: center;
        background-color: #f8f8f8;
      }
    }
    .recordlist-body {
      .recordlist-item {
        display: flex;
        &.even-row {
          background-color: #f8f8f8;
        }
        .item-address {
          width: 50%;
          padding: 16px;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #262626;
        }
        .item-time {
          width: 50%;
          width: 50%;
          padding: 16px;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #262626;
        }
      }
    }
  }
  .nomore {
    width: 100%;
    height: calc(100vh - 226px);
    display: flex;
    justify-content: center;
    align-items: center;
    .nomore-text {
      font-size: 14px;
      color: #8c8c8c;
      width: 200px;
      height: 200px;
      background-image: url('../../assets/image/activecheck/pic.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      position: relative;
      .text {
        position: absolute;
        bottom: 16px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>
